
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 0h13v13h-2.011V2.012H32V0zM0 0h13v2.012H2.012V13H0V0zm42.988 32H45v13H32v-2.012h10.988V32zM0 32h2.012v10.988H13V45H0V32z","fill":"#FFF"}})])
          )
        }
      }
    